import View from '../../../Core/View.js';
import convertJson from './JsonHandler.js';
import styleContainer from './mapStyle.json';

class AllLocationsMap extends View {

	initialize() {
		const pulledJson = this.el.getAttribute("data-locations");
		this.positions = convertJson(pulledJson);

		const config = {
			zoom: this._createValidZoomLevel(this.el.getAttribute('data-zoom')),
			center: this._createCenterPoint(this.el.getAttribute('data-center')),
			scrollwheel: false,
			styles: styleContainer,
			mapTypeControl: false,
		};
		const mapElement = this.el.querySelector('.all-locations__map-container');
		this.map = new google.maps.Map(mapElement, config);
		this.positions.forEach(point => {
			this._createMarker(point);
		});
	}

	_icon() {
		return {
			path: "M48,1.4c20.4,0,36.9,16.5,36.9,36.9c0,25.4-23.4,63.5-32.9,78c-1.9,2.9-6.2,2.9-8.1,0C34.3,102.2,11.1,65,11.1,38.4 C11.1,18,27.6,1.4,48,1.4z M64.8,38.4c0-9.3-7.5-16.8-16.8-16.8s-16.8,7.5-16.8,16.8S38.7,55.2,48,55.2S64.8,47.6,64.8,38.4z",
			fillColor: '#1F375A',
			fillOpacity: 1,
			strokeWeight: 0,
			scale: 0.3,
			anchor: new google.maps.Point(40, 120)
		};
	}

	_createMarker(location) {
		const marker = new google.maps.Marker({
			animation: google.maps.Animation.DROP,
			position: location['coordinates'],
			map: this.map,
			icon: this._icon(),
			url: location['linkTo']
		});
		google.maps.event.addListener(marker, 'click', this._onMarkerClickListener(marker, location))
	}

	_onMarkerClickListener(marker, location) {
		google.maps.event.addListener(marker, 'click', function() {
			window.location.href = location['redirect'];
		});
	}
	_createCenterPoint(centerPointString) {
		const centerPointValidArray = centerPointString.split(' ');
		return {
			lat: parseFloat(centerPointValidArray[0]),
			lng: parseFloat(centerPointValidArray[1])
		}
	}

	_createValidZoomLevel(zoom) {
		return parseFloat(zoom);
	}

}
export default AllLocationsMap;


// WEBPACK FOOTER //
// ./js/Views/Modules/AllLocationsMap/AllLocationsMap.js